import { Service } from "@/Common/Api/Services/Dto/Responses/Service";
import { ServiceDefinition } from "@/Common/Api/Services/Dto/Responses/ServiceDefinition";

class ServiceDefinitionDTO extends ServiceDefinition {
    public EmployeesContactFacetIds: string[];
    public EmployeeServices: Service[];
    public NameEN: string;
    public NameFR: string;
    public NameES: string;
    public OnlineNameEN: string;
    public OnlineNameFR: string;
    public OnlineNameES: string;
    public OnlineDescriptionEN: string;
    public OnlineDescriptionFR: string;
    public OnlineDescriptionES: string;
    public OnlineDisclaimerEN: string;
    public OnlineDisclaimerFR: string;
    public OnlineDisclaimerES: string;
}

export { ServiceDefinitionDTO };
